import { useCallback, useState } from "react";
import izenuAPI from "../../../services/izenuAPI";
import AdLinkBadge from "./AdLinkBadge";
import AdActiveToggle from "./AdActiveToggle";
import EditAdModal from "./EditAdModal";

const formatDuration = (ms) => {
    if (!ms || ms <= 0) return "";
    const totalSec = Math.round(ms / 1000);
    const min = Math.floor(totalSec / 60);
    const sec = totalSec % 60;
    if (min === 0) return `${sec}s`;
    return `${min}:${sec.toString().padStart(2, "0")}`;
};

export default function AdsAudioCard({ item, onDeleted, onEdited }) {
    const [showOption, setShowOption] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);

    const deleteAds = useCallback(async () => {
        if (!window.confirm("Apagar é irreversível, tem certeza?")) return;
        setLoading(true);
        try {
            const { data: r } = await izenuAPI.post("/admin/ads/delete.php", { ads_id: item.id, type: "audio" });
            if (r.response) {
                alert("Apagado com sucesso!");
                if (onDeleted) onDeleted(item.id);
            } else {
                alert("Impossível apagar, tente mais tarde!");
            }
        } catch (err) {
            console.log(err);
            alert("Impossível apagar, tente mais tarde!");
        }
        setLoading(false);
    }, [item, onDeleted]);

    if (loading) {
        return (
            <div className="relative border p-3 mb-3 rounded-lg bg-rose-500/30">
                <span className="text-white">A apagar...</span>
            </div>
        );
    }

    return (
        <div className="relative border p-3 mb-3 rounded-lg flex gap-3 items-center">
            {item.cover_url && (
                <img style={{ opacity: item.active === 0 ? 0.4 : 1 }}
                    src={item.cover_url}
                    alt={item.title}
                    className="w-20 h-20 object-cover rounded cursor-pointer flex-shrink-0"
                    onClick={() => setShowOption(true)}
                />
            )}
            <div className="flex-1 min-w-0">
                <p className="font-semibold text-sm truncate">{item.title}</p>
                {item.info && <p className="text-xs text-gray-500 truncate">{item.info}</p>}
                <div className="flex items-center gap-2 mt-1 text-xs text-gray-500">
                    {item.duration > 0 && <span>{formatDuration(item.duration)}</span>}
                    {item.exp_date && <span>• exp {item.exp_date}</span>}
                </div>
                <div className="flex items-center gap-2 flex-wrap">
                    <AdActiveToggle type="audio" id={item.id} active={item.active} onChanged={() => onEdited && onEdited()} />
                    <AdLinkBadge link={item.link} />
                </div>
                <audio controls src={item.audio_url} className="mt-2 w-full" style={{ height: 30 }}>
                    O teu browser não suporta áudio.
                </audio>
            </div>
            {showOption && (
                <div
                    onClick={() => setShowOption(false)}
                    className="rounded-lg backdrop-blur-sm bg-white/30 flex items-center justify-center gap-2 absolute inset-0"
                >
                    <button
                        onClick={(e) => { e.stopPropagation(); setShowOption(false); setEditing(true); }}
                        className="text-sm h-10 px-6 font-medium bg-sky-500 rounded text-white"
                    >
                        Editar
                    </button>
                    <button onClick={deleteAds} className="text-sm h-10 px-6 font-medium bg-rose-500 rounded text-white">
                        Apagar
                    </button>
                </div>
            )}
            <EditAdModal
                open={editing}
                onClose={() => setEditing(false)}
                onSaved={() => onEdited && onEdited()}
                ad={item}
                type="audio"
            />
        </div>
    );
}
